const gatesParamsSearchActions = {
  GATES_PARAMS_SEARCH_INIT_STATE_SET: 'GATES_PARAMS_SEARCH_INIT_STATE_SET',
  GATES_PARAMS_SEARCH_PROP_UPDATE: 'GATES_PARAMS_SEARCH_PROP_UPDATE',
  GATES_PARAMS_SEARCH_PROP_DELETE: 'GATES_PARAMS_SEARCH_PROP_DELETE'
};
export default gatesParamsSearchActions;
